import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import ActionsContainer from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/actionsContainer';
import { StyledTypography } from 'styles/common';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { startSurvey } from 'services/engagement';
import { showSuccessSnackbar, showErrorSnackbar } from 'services/snackbar';

import { DeerFooterContainer } from '../DeerFooterContainer';
import NameSummary from './NameSummary';
import ParticipantsSummary from './ParticipantsSummary';
import ReminderSummary from './ReminderSummary';
import SettingsSummary from './SettingsSummary';
import TemplateSummary from './TemplateSummary';

const Summary = ({ formId, backFn, nextFn, isDraft }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const save = () => {
    setLoading(true);
    startSurvey({ surveyId: formId })
      .then((res) => {
        dispatch(showSuccessSnackbar(res.message));
        nextFn();
      })
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to save the survey'));
      })
      .finally(() => setLoading(false));
  };

  const props = { formId };

  return (
    <>
      <StyledTypography variant="h5" color="#333" bottomGutter={1}>
        Verify
      </StyledTypography>
      <StyledTypography variant="body" color="#999">
        You are almost done. Just check the survey configuration.
      </StyledTypography>
      <>
        <NameSummary {...props} />
        <ParticipantsSummary {...props} />
        <TemplateSummary {...props} />
        <SettingsSummary {...props} />
        <ReminderSummary {...props} />
      </>
      {isDraft ? (
        <ActionsContainer
          ContainerComp={checkNewNavEnabled() ? DeerFooterContainer : null}
          loading={loading}
          onBackClick={backFn}
          onNextClick={nextFn && save}
          nextText="Create survey"
          nextDisabled={false}
        />
      ) : (
        <ActionsContainer
          ContainerComp={checkNewNavEnabled() ? DeerFooterContainer : null}
          loading={loading}
          onBackClick={backFn}
          onNextClick={nextFn}
          nextText="close"
          nextDisabled={false}
        />
      )}
    </>
  );
};

export default Summary;
